import "./app.scss";
import template from "./app.html";
import {Base} from "./base";
import toastr from "toastr";
import {Options} from "vue-class-component";

import termsAndConditions from "../assets/static/terms-and-conditions.pdf";
import privacyPolicy from "../assets/static/privacy-policy.pdf";

import axios from "axios";

import elements from "canvg/lib/Document/elements";

toastr.options.closeButton = false;
toastr.options.timeOut = 10 * 1000;
toastr.options.extendedTimeOut = 20 * 1000;
toastr.options.progressBar = true;
toastr.options.positionClass = "toast-bottom-left";
toastr.options.closeDuration = 250;

@Options({
	template,
})
export class App extends Base {
	showMenu = false;
	menu: any[] = [];
	meniItems: any = [];

	get terms(){
		return termsAndConditions
	}

	get privacy(){
		return privacyPolicy
	}

	get menu_class() {
		return [
			"menu",
			this.showMenu ? "show" : ""
		];
	}

	get menuItems() {
		return this.$wp.header.menu
	}

	/** Lifecycle */
	created() {
		this.init().catch(this.errorHandle);
	}

	/** Methods */
	async init() {
		this.loading = true;
		const href = new URL(window.location.href)
		const res = await axios.get(`${href.origin}/wp-json/menus/v1/menus/menu`)
		this.meniItems = res.data.items
		// console.log(this.meniItems)

		/** Menu */
		this.menu = [
			{
				label: "Home",
				path: "/",
			}
		];

		this.loading = false;
	}

	logout() {
		localStorage.clear();
		location.pathname = "/";
	}
}
